/**
 * Sección "Mis pagos" — histórico de cobros recibidos por el promotor.
 * Se monta en Réditos. Carga async de GET /api/cashier/mis-pagos.
 * Read-only: el promotor ve "te pagaron R$ X el día Y · ref Z".
 */
import { t } from '../languages.js';
import { montoDisplay } from './_helpers.js';
import { escapeHtml } from '../systems/escape-html.js';

/**
 * Devuelve el contenedor de la sección. Carga los pagos async y los pinta.
 * @param {{ apiGet: (url:string)=>Promise<any> }} ctx
 * @returns {HTMLElement}
 */
export function renderSeccionMisPagos({ apiGet }) {
    const el = document.createElement('div');
    el.className = 'card';
    el.style.cssText = 'margin-top:10px;';
    el.innerHTML = `
        <h2 style="margin:0 0 10px;">${t('misPagos.titulo')}</h2>
        <div id="pm-mis-pagos-body">
            <div style="text-align:center; color:var(--text-dim); padding:16px;">${t('common.cargando')}</div>
        </div>`;

    const body = el.querySelector('#pm-mis-pagos-body');

    (async function cargar() {
        const r = await apiGet('/api/cashier/mis-pagos');
        if (!r || r.ok === false) {
            body.innerHTML = `<div style="color:var(--text-dim); font-size:14px;">${t('misPagos.error')}</div>`;
            return;
        }
        const pagos = r.pagos || [];
        if (pagos.length === 0) {
            body.innerHTML = `<div style="color:var(--text-dim); font-size:14px; padding:8px 0;">${t('misPagos.vacio')}</div>`;
            return;
        }
        body.innerHTML = pagos
            .map(p => {
                const fecha = p.fecha ? String(p.fecha).slice(0, 10) : '';
                const ref = p.referencia ? ` · ${escapeHtml(String(p.referencia))}` : '';
                const metodo = p.metodo ? ` · ${escapeHtml(String(p.metodo))}` : '';
                return `
                    <div style="display:flex; justify-content:space-between; align-items:baseline; padding:8px 0; border-bottom:1px solid var(--border);">
                        <div style="font-size:14px; color:var(--text-dim);">${fecha}${metodo}${ref}</div>
                        <div style="font-size:16px; font-weight:700; color:var(--success);">${montoDisplay(p.monto)}</div>
                    </div>`;
            })
            .join('');
    })();

    return el;
}

